export class HubAccessDeniedError extends Error {
    constructor(
        public readonly hubMethod: string,
        public readonly detail: string,
        public readonly cause?: unknown,
    ) {
        super(`Hub access denied on '${hubMethod}': ${detail}`);
        this.name = 'HubAccessDeniedError';
        Object.setPrototypeOf(this, HubAccessDeniedError.prototype);
    }
}
